import React from "react";
import ReactDOM from "react-dom";
import ReactGA from 'react-ga';
import { transitions, positions, Provider as AlertProvider } from "react-alert";
import CssBaseline from "@material-ui/core/CssBaseline";
import AlertTemplate from "./components/AlertTemplate";

import App from "./App";
import * as serviceWorker from "./serviceWorker";

if (process.env.NODE_ENV === 'production') {
    ReactGA.initialize('UA-130884114-1');
    ReactGA.pageview(window.location.pathname + window.location.search);
} else {
    ReactGA.initialize('UA-130884114-1', {
        debug: true,
    });
}

const alertOptions = {
    offset: "15px",
    position: positions.TOP_RIGHT,
    timeout: 10000,
    transition: transitions.FADE
};

const Root = () => (
    <AlertProvider template={AlertTemplate} {...alertOptions}>
        <CssBaseline />
        <App/>
    </AlertProvider>
);

ReactDOM.render(<Root/>, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// if (process.env.NODE_ENV === "production") {
//     serviceWorker.register();
// }
serviceWorker.unregister();
